import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  inject,
} from '@angular/core';
import { TransactionType } from '@shared/helpers/enums/transaction-type';
import { SecurityReviewUpdate } from '../../abstractions/security-review-update';
import { SecurityTaxResultItemReview } from '../../models/edit-tax-result-approval/security-tax-result-item-review';
import { TaxResultSessionService } from '../../services/tax-result-session.service';

@Component({
  standalone: false,
  selector: 'gstar-tax-result-fieldset',
  templateUrl: './tax-result-fieldset.component.html',
  styleUrls: ['./tax-result-fieldset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxResultFieldsetComponent {
  private readonly taxResultSession = inject(TaxResultSessionService);

  securityTaxResultItem = model.required<SecurityTaxResultItemReview>();
  transactionType = input<TransactionType>();
  isDisabled = input<boolean>(false);
  title = input<string>('');

  get isGeneralRates(): boolean {
    return this.transactionType() === TransactionType.GeneralRates;
  }

  updateFieldHandler(securityReviewUpdate: SecurityReviewUpdate): void {
    this.taxResultSession.updateSecurity.next(securityReviewUpdate);
  }

  updateAllFieldExplanationHandler({
    securityTaxResultItem,
  }: SecurityReviewUpdate): void {
    this.securityTaxResultItem().items.update(items => {
      return items.map(item => {
        item.explanation!.value.set(securityTaxResultItem.explanation!.value());
        return item;
      });
    });

    this.taxResultSession.updateSecurity.next({
      field: 'explanation',
      metadata: securityTaxResultItem.metadata,
      securityTaxResultItem,
    });
  }
}
